import {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import _ from 'lodash';
import SimpleTable from '../../simpleTable/SimpleTable.component';
import { TableBody, TableRow } from '@mui/material';
import { grey } from '@mui/material/colors';
import { StatusLogbookDeliveries } from '../../../module/logbook/conf/Data.conf';
import { HEIGHT_TABLE_ITEMS_COLLAPSE } from '../../../module/listItem/conf/Data.conf';
import TableRowLogbook from '../tableEditable/components/TableRowLogbook.component';
import TableItemsLogbookEditable from '../tableEditable/TableItemsLogbookEditable.component';

const idAccordion = '[0].attributes.id_logbook.data.id';

const TabOrdered = ({
  data,
  operationListData,
  orderType = 'asc',
  orderById,
  header = [],
  valueTab,
  setSuccessUpdate = () => {},
  module,
  headerCollapse,
  code,
  checkedByLogbook = {},
  onCheckedByLogbookChange = () => {},
}) => {
  const tableRef = useRef(null);
  const [scrollToId, setScrollToId] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [orderBy, setOrderBy] = useState(orderById);
  const [order, setOrder] = useState(orderType);
  const idLogbookStore = localStorage.getItem('idLogbook');

  //Sort logbooks for label supplier
  const sortedExternalData = useMemo(() => {
    const dataOrdered = _.orderBy(data, `[0].${orderBy}`, [order]);
    let confirmedItems = [];
    let othersItems = [];
    dataOrdered.map((item) =>
      _.toUpper(
        item[0]?.attributes?.id_logbook?.data?.attributes?.status_logbook
      ) !== 'COMPLETED'
        ? othersItems.push(item)
        : confirmedItems.push(item)
    );

    return [...confirmedItems, ...othersItems];
  }, [orderBy, order, data]);

  // Stable progressive index (1 = oldest) based on logbook id asc, independent of current sort
  const stableIndexMap = useMemo(() => {
    const sorted = _.orderBy(data, (item) => _.get(item, '[0].attributes.id_logbook.data.id'), ['asc']);
    return sorted.reduce((acc, item, idx) => {
      const logbookId = _.get(item, idAccordion);
      if (logbookId != null) acc[logbookId] = idx + 1;
      return acc;
    }, {});
  }, [data]);

  const handleSort = (columnId) => {
    const isAsc = orderBy === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(columnId);
  };

  const handleChange = (id, logbookId) => {
    setExpanded({ [id]: !expanded?.[id] });
    setScrollToId(logbookId);
  };

  const onSuccess = useCallback(
    (logbookId) => {
      localStorage.setItem('idLogbook', logbookId);
      setSuccessUpdate((prev) => !prev);
    },
    [setSuccessUpdate]
  );

  useEffect(() => {
    if (sortedExternalData) {
      setExpanded(
        _.mapValues(
          _.keyBy(sortedExternalData, (item) => _.get(item, idAccordion)),
          (value) =>
            `${idLogbookStore}` &&
              `${_.get(value, idAccordion)}` === `${idLogbookStore}`
              ? true
              : false
        )
      );
    }
  }, [sortedExternalData, idLogbookStore]);

  useEffect(() => {
    if (idLogbookStore && parseInt(idLogbookStore) && tableRef?.current) {
      const row = tableRef.current.querySelector(`#row-${idLogbookStore}`);

      if (row) {
        row.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [idLogbookStore, tableRef]);

  useEffect(() => {
    if (scrollToId && tableRef?.current) {
      const row = tableRef.current.querySelector(`#row-${scrollToId}`);
      if (row) {
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      setScrollToId(null);
    }
  }, [expanded, scrollToId]);

  return (
    <SimpleTable
      minHeight={HEIGHT_TABLE_ITEMS_COLLAPSE}
      module={{ list: { conf: { columns: header } } }}
      onSort={handleSort}
      order={order}
      orderBy={orderBy}
      data={sortedExternalData}
      body={
        <TableBody ref={tableRef}>
          {sortedExternalData?.map((item) => {
            const logbook = _.get(item, '[0].attributes.id_logbook.data');
            const id = _.get(item, idAccordion);
            const deliveryNote = _.get(operationListData, 'attributes.id_delivery_note.data');
            const color = _.find(
              StatusLogbookDeliveries,
              (element) =>
                element.label.toUpperCase() ===
                logbook?.attributes?.status_logbook?.toUpperCase()
            );
            return (
              <Fragment key={id}>
                <TableRowLogbook
                  open={expanded?.[id] || false}
                  onChangeExpanded={() => handleChange(id, logbook?.id)}
                  logbook={logbook}
                  id={id}
                  color={color}
                  deliveryNote={deliveryNote}
                  items={item}
                  operationListData={operationListData}
                  setSuccessUpdate={setSuccessUpdate}
                  code={code}
                  supplierRowIndex={stableIndexMap[id] ?? 0}
                />
                <TableRow
                  sx={{
                    backgroundColor: expanded?.[id] && grey[100],
                  }}
                >
                  <TableItemsLogbookEditable
                    open={expanded?.[id]}
                    data={item}
                    idLogbook={id}
                    valueTab={valueTab}
                    handleSuccess={() => onSuccess(id)}
                    statusLogbook={logbook?.attributes?.status_logbook}
                    module={module}
                    header={headerCollapse}
                    checked={checkedByLogbook[id] || {}}
                    onCheckedChange={(newChecked) =>
                      onCheckedByLogbookChange((prev) => ({ ...prev, [id]: newChecked }))
                    }
                  />
                </TableRow>
              </Fragment>
            );
          })}
        </TableBody>
      }
    />
  );
};
export default TabOrdered;
